import { HouseCreativeBean, HouseCreativeControllerApi, ItemResponseHouseCreativeBeanObject, ListResponseHouseCreativeBean } from 'src/api/api';
import { BaseApi, configuration } from '../../../api/BaseApi';
import { processError } from '../../../api/customFetch';

class HouseCreativeApi extends BaseApi {
    api: HouseCreativeControllerApi;

    constructor() {
        super();
        this.api = new HouseCreativeControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    list(size: number = 20, page: number = 1, search?): Promise<ListResponseHouseCreativeBean> {
        return this.api.creativeList(search, {query: {size, page}}).then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    all(): Promise<ListResponseHouseCreativeBean> {
        return this.api.creativeList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    create(HouseCreative: HouseCreativeBean): Promise<ItemResponseHouseCreativeBeanObject> {
        return this.api.createCreative(HouseCreative).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, HouseCreative: HouseCreativeBean): Promise<ItemResponseHouseCreativeBeanObject> {
        return this.api.editCreative( HouseCreative, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id: number): Promise<ItemResponseHouseCreativeBeanObject> {
        return this.api.creative(id).then(HouseCreative => {
            return Promise.resolve(HouseCreative);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteCreative(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }
}

const houseCreativeApi = new HouseCreativeApi();

export default houseCreativeApi;
